import { render, staticRenderFns } from "./CloneEventToTeamModal.vue?vue&type=template&id=3b4dff24&scoped=true&"
import script from "./CloneEventToTeamModal.vue?vue&type=script&lang=js&"
export * from "./CloneEventToTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./CloneEventToTeamModal.vue?vue&type=style&index=0&id=3b4dff24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4dff24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCheckbox,VSelect})
